import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=042093c5&scoped=true&"
import script from "./personnel.vue?vue&type=script&lang=js&"
export * from "./personnel.vue?vue&type=script&lang=js&"
import style0 from "./personnel.vue?vue&type=style&index=0&id=042093c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042093c5",
  null
  
)

export default component.exports